import React, { useEffect, useState } from 'react';
import { useUserPreferences } from '../../hooks/useUserPreferences';
import { useBooleanFeatureFlag } from '../../hooks/useFeatureFlags';
import { useIDECheckins } from '../../hooks/useIDECheckins';
import useAnalytics from '../../hooks/useAnalytics';
import { ExtensionBanner } from './ExtensionBanner';

export default function ExtensionBannerRenderer() {
  const { data: ideCheckins, isLoading: checkinsLoading } = useIDECheckins();
  const { showExtensionBanner, updateUserPreferences } = useUserPreferences();
  const enableExtensionBannerFF = useBooleanFeatureFlag('show-extension-banner');
  const analytics = useAnalytics();

  const [showBanner, setShowBanner] = useState(false);
  const [locallyDismissBanner, setLocallyDismissBanner] = useState(false);

  useEffect(() => {
    if (checkinsLoading || locallyDismissBanner) {
      setShowBanner(false);
      return;
    }

    const noCheckinsData = Object.entries(ideCheckins).length === 0;
    setShowBanner(showExtensionBanner && noCheckinsData);
  }, [checkinsLoading, ideCheckins, showExtensionBanner, locallyDismissBanner]);

  const handleDontShowBanner = () => {
    analytics.capture('dont_show_extension_banner_clicked');
    updateUserPreferences({ showExtensionBanner: false });
    setShowBanner(false);
  };

  const handleCloseBanner = () => {
    analytics.capture('dismiss_extension_banner_clicked');
    setLocallyDismissBanner(true);
    setShowBanner(false);
  };

  if (enableExtensionBannerFF && showBanner) {
    return (
      <ExtensionBanner
        onClose={handleCloseBanner}
        onDontShowAgain={handleDontShowBanner}
      />
    );
  }

  return null;
}
